<script setup lang="ts">
import { useBaseStore } from "@/stores/base";
const baseStore = useBaseStore();
</script>

<template>
	<v-container class="h-100" v-if="baseStore.loadingWrapper">
		<v-row class="fill-height" align-content="center" justify="center">
			<v-col class="text-subtitle-1 text-center" cols="12">
				Setting up module
			</v-col>
			<v-col cols="6">
				<v-progress-linear color="primary" indeterminate rounded height="6" />
			</v-col>
		</v-row>
	</v-container>
	<slot v-else></slot>
</template>
